<template>
  <div>
    <v-divider v-if="divider"></v-divider>
    <v-layout row wrap>
      <v-flex xs7>
        <h3 class="subheading font-weight-bold pb-1">
          <slot name="title"></slot>
        </h3>
        <slot name="description"></slot>
      </v-flex>
      <v-flex xs4 offset-xs-1 text-xs-right>
        <slot name="form"></slot>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  name: 'ConfigItem',
  props: {
    divider: {
      type: Boolean,
      required: false,
      default: false
    }
  }
}
</script>